import { memo, useEffect, useState } from "react";
import CancelButton from "../../../framework/forms/helpercomponents/buttons/CancelButton";
import SaveButton from "../../../framework/forms/helpercomponents/buttons/SaveButton";
import * as API from '../../../framework/API/api'
import { ENTITYNAME, MEDIACATEGORIES, PLATFORMTYPE, PUBLISHING_SOURCE } from "../../../framework/constant/constant";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { toast } from "react-toastify";
import AddRoundButton from "../../../framework/forms/helpercomponents/buttons/AddRoundButton";
import AudioTrack from "../AudioTrack";
import MediaDealRightEditForm from "./component/mediaDealRightEditForm";
import moment from "moment";
import { utility } from "../../../framework/utility/utilityProvider";
import { ConfirmDeleteAlert } from "../../../ConfirmAlert";
import DeleteRoundButton from "../../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { useTranslation } from "../../../locale/useTranslation";
import MyMultiSelect from "../../../components/MyMultiSelect";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import CollectionSelection from "../../../framework/forms/CollectionSelection";
import CreateTransmissionForm from "../../../framework/OTT/CreateTransmissionForm";

const MultipleContentEditPanel = (props) => {

    const { selectedItems = [], setSelectedItems, entityName, mediaCategory = {}, gridData = [], setGridData, mainStyle = {}, onClose, contentCategory = {} } = props;

    const lang = useTranslation();
    const subHeadingStyle = { fontFamily: "Roboto", fontSize: "13px", fontWeight: "500", letterSpacing: "0.2px", lineHeight: "18px", color: "#191825", margin: "7px 10px", padding: 0 }
    const style = { display: "grid", gridTemplateColumns: "0.9fr 1.1fr", alignItems: "start", padding: "10px 0" }
    const width = "235px";
    const tableDataStyle = { fontFamily: "Roboto", fontSize: "13px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", padding: "10px" };
    const isHideMetaDataFields = entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season;

    const [pgRatings, setPGRatings] = useState([]);
    const [showMediadealrights, setShowMediadealrights] = useState({ show: false, isLinear: false });
    const [censorRatings, setCensorRatings] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [categories, setCategories] = useState([]);
    const [genres, setGenres] = useState([]);
    const [selectedFields, setSelectedFields] = useState({
        PGRating: { isSelected: false, value: null },
        CensorRating: { isSelected: false, value: null },
        Languages: { isSelected: false, value: null },
        ProductionYear: { isSelected: false, value: null },
        Categories: { isSelected: false, value: null },
        Genres: { isSelected: false, value: null },
        SubGenres: { isSelected: false, value: null },
        AudioTrack: { isSelected: false, value: null },
        linearRights: { isSelected: false, value: [] },
        nonLinearRights: { isSelected: false, value: [] },
        Keywords: { isSelected: false, value: null },
        offers: { isSelected: false, value: [] },
        // OttAsset: { isSelected: false, value: [] }
    });
    const [showAttachOffers, setShowAttachOffers] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        let pgRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        if (pgRes.success) setPGRatings(pgRes.data);
        let crRes = await API.getDataLookup(ENTITYNAME.CensorRating, { sort: { Description: 1 } });
        if (crRes.success) setCensorRatings(crRes.data);
        let languages = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        if (languages.success) setLanguages(languages.data);
        let categories = await API.getDataLookup(ENTITYNAME.ContentCategory, { sort: { Name: 1 } });
        if (categories.success) setCategories(categories.data);
        let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        if (genreRes.success) setGenres(genreRes.data);
    }

    const onCheckBoxSelection = (e) => {
        let key = e.target.name;
        setSelectedFields((old) => ({ ...old, [key]: { ...old[key], isSelected: e.target.value } }));
    }

    const onFieldValueChange = (e) => {
        let key = e.target.name;
        setSelectedFields((old) => ({ ...old, [key]: { ...old[key], value: e.target.value } }));
    }

    const setAudioTrackData = (data) => {
        setSelectedFields((old) => ({ ...old, AudioTrack: { ...old.AudioTrack, value: data } }));
    }

    // const handleSubmitOld = async () => {
    //     let saveData = {};
    //     let updatedSelectedItems = [...selectedItems];
    //     let updatedValues = {};

    //     // ---------- Prepare saveData ----------
    //     Object.keys(selectedFields).forEach((key) => {
    //         if (selectedFields[key].isSelected && !['Genres', 'SubGenres', 'linearRights', 'nonLinearRights'].includes(key)) {
    //             saveData[key] = selectedFields[key].value;
    //         }
    //     });

    //     // ---------- GENRES ----------
    //     if (selectedFields.Genres.isSelected) {
    //         const Genres = selectedFields.Genres.value?.map((x) => ({
    //             _id: x._id,
    //             Description: x.Description
    //         })) || [];

    //         updatedValues.Genres = Genres;
    //         updatedSelectedItems = updatedSelectedItems.map((x) => {
    //             return { ...x, Genres };
    //         });
    //     }

    //     // ---------- SUB GENRES ----------
    //     if (selectedFields.SubGenres.isSelected) {
    //         const SubGenres = selectedFields.SubGenres.value?.map((x) => ({
    //             _id: x._id,
    //             Description: x.Description
    //         })) || [];

    //         updatedValues.SubGenres = SubGenres;
    //         updatedSelectedItems = updatedSelectedItems.map((x) => {
    //             return { ...x, SubGenres };
    //         });
    //     }

    //     if (selectedFields.Genres.isSelected || selectedFields.SubGenres.isSelected) {
    //         const query = ["_id", "in", updatedSelectedItems.map(x => x._id)];
    //         await API.bulkUpdate(isHideMetaDataFields ? entityName : ENTITYNAME.MediaEpisode, updatedValues, query);
    //     }

    //     // ---------- RIGHTS (COMMON SOURCE) ----------
    //     const publishingSource =
    //         mediaCategory?.SID === MEDIACATEGORIES.Series
    //             ? PUBLISHING_SOURCE.Series
    //             : mediaCategory?.SID === MEDIACATEGORIES.Season
    //                 ? PUBLISHING_SOURCE.Season
    //                 : PUBLISHING_SOURCE.MediaEpisode;

    //     // ---------- LINEAR RIGHTS ----------
    //     if (selectedFields.linearRights.isSelected) {
    //         const saveLinearRights = selectedFields.linearRights.value.map((r) => {
    //             const { _id, ...rest } = r;
    //             return rest;
    //         });

    //         await Promise.all(
    //             updatedSelectedItems.map(async (item) => {
    //                 const res = await API.updateMediaDealRights(
    //                     item,
    //                     [],
    //                     saveLinearRights,
    //                     publishingSource
    //                 );

    //                 if (!res.success) {
    //                     toast.error('Failed to save Linear Rights');
    //                 } else {
    //                     updatedSelectedItems = updatedSelectedItems.map((x) =>
    //                         x._id === item._id
    //                             ? { ...x, Publishings: saveLinearRights }
    //                             : x
    //                     );
    //                 }
    //             })
    //         );
    //     }

    //     // ---------- NON-LINEAR RIGHTS ----------
    //     if (selectedFields.nonLinearRights.isSelected) {
    //         const saveNonLinearRights = selectedFields.nonLinearRights.value.map((r) => {
    //             const { _id, ...rest } = r;
    //             return rest;
    //         });

    //         await Promise.all(
    //             updatedSelectedItems.map(async (item) => {
    //                 const res = await API.updateMediaDealRights(
    //                     item,
    //                     [],
    //                     saveNonLinearRights,
    //                     publishingSource
    //                 );

    //                 if (!res.success) {
    //                     toast.error('Failed to save Non-Linear Rights');
    //                 } else {
    //                     updatedSelectedItems = updatedSelectedItems.map((x) =>
    //                         x._id === item._id
    //                             ? { ...x, Publishings: saveNonLinearRights }
    //                             : x
    //                     );
    //                 }
    //             })
    //         );
    //     }

    //     // ---------- OFFERS ----------
    //     if (selectedFields.offers.isSelected) {
    //         const saveOfferRights = selectedFields.offers.value.map((r) => {
    //             const { _id, ...rest } = r;
    //             return rest;
    //         });

    //         await Promise.all(
    //             updatedSelectedItems.map(async (item) => {
    //                 const res = await API.updateOffers(
    //                     item,
    //                     [],
    //                     saveOfferRights,
    //                     publishingSource
    //                 );
    //                 console.log(res);


    //                 if (!res.success) {
    //                     toast.error('Failed to save Offer Rights');
    //                 } else {
    //                     updatedSelectedItems = updatedSelectedItems.map((x) =>
    //                         x._id === item._id
    //                             ? { ...x, Publishings: saveOfferRights }
    //                             : x
    //                     );
    //                 }
    //             })
    //         );
    //     }

    //     // ---------- METADATA (LAST UPDATE ONLY) ----------
    //     if (Object.keys(saveData).length > 0) {
    //         let finalData = {};
    //         if (selectedFields.PGRating.isSelected) {
    //             finalData.PGRating = (saveData?.PGRating && Object.keys(saveData.PGRating).length > 0) ? { _id: saveData.PGRating._id, Description: saveData.PGRating.Description } : {}
    //         }

    //         if (selectedFields.Languages.isSelected) {
    //             finalData.Languages = saveData?.Languages?.length > 0 ? saveData.Languages?.map(x => { return { _id: x._id, Description: x.Description } }) : [];
    //         }

    //         if (selectedFields.ProductionYear.isSelected) {
    //             finalData.ProductionYear = saveData?.ProductionYear;
    //         }

    //         if (selectedFields.Keywords.isSelected) {
    //             finalData.Keywords = saveData?.Keywords;
    //         }

    //         if (selectedFields.Categories.isSelected) {
    //             finalData.Categories = saveData?.Categories?.length > 0 ? saveData?.Categories?.map(x => { return { _id: x._id, Name: x.Name, parent: x.parent } }) : [];
    //         }

    //         if (isHideMetaDataFields) {
    //             const query = ["_id", "in", updatedSelectedItems.map(x => x._id)];
    //             await API.bulkUpdate(entityName, finalData, query);


    //             updatedSelectedItems = updatedSelectedItems.map((x) => {
    //                 return { ...x, MetaData: { ...x.MetaData, ...finalData } };
    //             });

    //         } else {

    //             if (selectedFields.CensorRating.isSelected) {
    //                 finalData.CensorRating = (saveData?.CensorRating && Object.keys(saveData.CensorRating).length > 0) ? { _id: saveData.CensorRating._id, Description: saveData.CensorRating.Description } : {}
    //             }

    //             if (selectedFields.AudioTrack.isSelected) {
    //                 finalData.AudioTrack = (saveData?.AudioTrack?.length > 0) ? saveData.AudioTrack.map(x => {
    //                     return {
    //                         Language: {
    //                             "_id": x.Language?._id,
    //                             "Description": x.Language?.Description,
    //                         },
    //                         TrackNumber: x?.TrackNumber
    //                     }
    //                 }) : [];
    //             }

    //             const query = ["MediaEpisode_id", "in", updatedSelectedItems.map(x => x._id)];
    //             await API.bulkUpdate(ENTITYNAME.MediaEpisodeMetaData, finalData, query);

    //             updatedSelectedItems = updatedSelectedItems.map((x) => {
    //                 return { ...x, MetaData: { ...x.MetaData, ...finalData } };
    //             });
    //         }
    //     }

    //     // ---------- FINAL STATE UPDATE ----------
    //     setSelectedItems(updatedSelectedItems);
    //     setGridData(gridData.map((gridItem) => {
    //         const updatedItem = updatedSelectedItems.find(
    //             (sel) => sel._id === gridItem._id
    //         );
    //         return updatedItem ? { ...gridItem, ...updatedItem } : gridItem;
    //     }));
    //     setSelectedItems([]);
    //     toast.success('Saved Successfully');
    // };

    const onMediadealrightsSave = (data) => {
        console.log(data);
        if (data.PlatformType.SID == PLATFORMTYPE[0].SID) {
            setSelectedFields((old) => ({ ...old, linearRights: { ...old.linearRights, value: [...old.linearRights.value, data] } }));
        }
        else {
            setSelectedFields((old) => ({ ...old, nonLinearRights: { ...old.nonLinearRights, value: [...old.nonLinearRights.value, data] } }));
        }
    }

    const onMediadealrightsClose = (isLinear) => {
        setShowMediadealrights({ show: !showMediadealrights.show, isLinear: isLinear });
    }

    const onMediadealrightsDelete = async (data) => {
        if (data.PlatformType.SID == PLATFORMTYPE[0].SID) {
            setSelectedFields((old) => ({ ...old, linearRights: { ...old.linearRights, value: old.linearRights.value.filter((item) => item._id !== data._id) } }));
        }
        else {
            setSelectedFields((old) => ({ ...old, nonLinearRights: { ...old.nonLinearRights, value: old.nonLinearRights.value.filter((item) => item._id !== data._id) } }));
        }
    }

    const defaultStyle = {
        position: "absolute",
        top: "91px",
        right: selectedItems.length > 0 ? 0 : "-500px",
        width: "500px",
        height: "76%",
        backgroundColor: "white",
        transition: 'all 0.3s linear',
        overflow: 'auto'
    }

    const handleSubmit = async () => {

        console.log("here");

        let saveData = {};
        let updatedValues = {
            media: {},
            dealRights: [],
            metaData: {},
            offers: []
        };

        // ---------- Prepare saveData ----------
        Object.keys(selectedFields).forEach((key) => {
            if (selectedFields[key].isSelected && !['Genres', 'SubGenres', 'linearRights', 'nonLinearRights'].includes(key)) {
                saveData[key] = selectedFields[key].value;
            }
        });

        // ---------- GENRES ----------
        if (selectedFields.Genres.isSelected) {
            const Genres = selectedFields.Genres.value?.map((x) => ({
                _id: x._id,
                Description: x.Description
            })) || [];

            updatedValues.media.Genres = Genres;
        }

        // ---------- SUB GENRES ----------
        if (selectedFields.SubGenres.isSelected) {
            const SubGenres = selectedFields.SubGenres.value?.map((x) => ({
                _id: x._id,
                Description: x.Description
            })) || [];

            updatedValues.media.SubGenres = SubGenres;
        }

        // ---------- METADATA (LAST UPDATE ONLY) ----------
        if (Object.keys(saveData).length > 0) {

            if (selectedFields.PGRating.isSelected) {
                updatedValues.metaData.PGRating = (saveData?.PGRating && Object.keys(saveData.PGRating).length > 0) ? { _id: saveData.PGRating._id, Description: saveData.PGRating.Description } : {}
            }

            if (selectedFields.Languages.isSelected) {
                updatedValues.metaData.Languages = saveData?.Languages?.length > 0 ? saveData.Languages?.map(x => { return { _id: x._id, Description: x.Description } }) : [];
            }

            if (selectedFields.ProductionYear.isSelected) {
                updatedValues.metaData.ProductionYear = saveData?.ProductionYear;
            }

            if (selectedFields.Keywords.isSelected) {
                updatedValues.metaData.Keywords = saveData?.Keywords;
            }

            if (selectedFields.Categories.isSelected) {
                updatedValues.metaData.Categories = saveData?.Categories?.length > 0 ? saveData?.Categories?.map(x => { return { _id: x._id, Name: x.Name, parent: x.parent } }) : [];
            }

            if (selectedFields.CensorRating.isSelected) {
                updatedValues.metaData.CensorRating = (saveData?.CensorRating && Object.keys(saveData.CensorRating).length > 0) ? { _id: saveData.CensorRating._id, Description: saveData.CensorRating.Description } : {}
            }

            if (selectedFields.AudioTrack.isSelected) {
                updatedValues.metaData.AudioTrack = (saveData?.AudioTrack?.length > 0) ? saveData.AudioTrack.map(x => {
                    return {
                        Language: {
                            "_id": x.Language?._id,
                            "Description": x.Language?.Description,
                        },
                        TrackNumber: x?.TrackNumber
                    }
                }) : [];
            }
        }

        // ---------- LINEAR RIGHTS ----------
        if (selectedFields.linearRights?.isSelected) {
            updatedValues.dealRights.push(
                ...(Array.isArray(selectedFields.linearRights.value)
                    ? selectedFields.linearRights.value
                    : [selectedFields.linearRights.value])
            );
        }
        // ---------- NON LINEAR RIGHTS ----------
        if (selectedFields.nonLinearRights?.isSelected) {
            updatedValues.dealRights.push(
                ...(Array.isArray(selectedFields.nonLinearRights.value)
                    ? selectedFields.nonLinearRights.value
                    : [selectedFields.nonLinearRights.value])
            );
        }

        // ---------- OFFERS ----------
        if (selectedFields.offers?.isSelected) {
            updatedValues.offers.push(
                ...(Array.isArray(selectedFields.offers.value)
                    ? selectedFields.offers.value
                    : [selectedFields.offers.value])
            );
        }

        const payload = {
            mediaCategory: mediaCategory && Object.keys(mediaCategory)?.length > 0 ? { _id: mediaCategory._id, SID: mediaCategory.SID, Description: mediaCategory.Description } : {},
            contentCategory: contentCategory && Object.keys(contentCategory)?.length > 0 ? { _id: contentCategory._id, SID: contentCategory.SID, Name: contentCategory.Name, parent: contentCategory.parent } : {},
            selectedMedia: selectedItems?.length > 0 ? selectedItems.map(x => { return { _id: x._id, SID: x.SID, Title: x.Title, AssetId: x.AssetId  } }) : [],
            updatedValues
        }

        await API.bulkUpdateMediaByContentCategory(payload);

        if (selectedItems.length > 0) {
            let updatedItems = selectedItems.map((item) => {
                const { metaData, dealRights, offers, ...updatedValues } = payload.updatedValues;
                return {
                    ...item,
                    ...updatedValues,
                    MetaData: metaData,
                    Publishings: dealRights,
                    Offers: offers
                };
            });
            setSelectedItems(updatedItems);
            onClose && onClose(false);
        } else {
            setSelectedItems([]);
            onClose && onClose(true);
        }
        toast.success('Saved Successfully');
    };

    const handleAttachOffers = (offerData) => {
        console.log(offerData);
        const { Offers = [], ...otherItem } = offerData;

        // Check Duplicate offers 
        let newData = utility.checkDuplicateInData(Offers, selectedFields?.offers?.value.map(x => x?.Offer), "Title");

        let finalData = [];
        // preparing final data
        for (let offer of newData) {
            let data = {
                _id: undefined,
                ContractSID: 0, ContractNumber: '', Licensor: {}, Payee: {},
                source: entityName,
                ContractTitle: {},
                Offer: offer,
                ...otherItem,
                Archive: false,
            }
            finalData.push(data);
        }

        setSelectedFields((old) => ({
            ...old,
            offers: {
                ...old.offers,
                isSelected: true, 
                value: [...old.offers.value, ...finalData],
            },
        }));

        setShowAttachOffers(false);
    }

    return (
        <div style={{ ...defaultStyle, ...mainStyle }} >
            <div style={{ padding: "0 10px" }}>
                <div className="flex-container mb-2">
                    <h1 style={{ fontFamily: "Roboto", fontSize: "24px" }}>Edit Multiple Assets ({selectedItems.length})</h1>
                    <div className="flex-container-reverse flex-item-auto" style={{ padding: '9px' }}>
                        <CancelButton onClick={() => { setSelectedItems([]); onClose && onClose() }} />
                        <SaveButton onClick={handleSubmit} />
                    </div>
                </div>
                {/* PGRating */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="PGRating" value={selectedFields.PGRating.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Pg Rating</span>
                    </div>
                    <DropDownList
                        disabled={!selectedFields.PGRating.isSelected}
                        style={{ width: width }}
                        data={pgRatings}
                        name="PGRating"
                        textField="Description"
                        dataItemKey="_id"
                        onChange={onFieldValueChange}
                    />
                </div>}
                {/* Censor Rating */}
                {!isHideMetaDataFields && mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="CensorRating" value={selectedFields.CensorRating.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Censor Rating</span>
                    </div>
                    <DropDownList
                        disabled={!selectedFields.CensorRating.isSelected}
                        style={{ width: width }}
                        data={censorRatings}
                        name="CensorRating"
                        textField="Description"
                        dataItemKey="_id"
                        onChange={onFieldValueChange}
                    />
                </div>}
                {/* Languages */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="Languages" value={selectedFields.Languages.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Languages</span>
                    </div>
                    <MyMultiSelect
                        disabled={!selectedFields.Languages.isSelected}
                        style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                        data={languages}
                        name="Languages"
                        textField="Description"
                        dataItemKey="_id"
                        onChange={onFieldValueChange}
                    />
                </div>}
                {/* Production Year */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="ProductionYear" value={selectedFields.ProductionYear.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Production Year</span>
                    </div>
                    <input
                        disabled={!selectedFields.ProductionYear.isSelected}
                        name='ProductionYear'
                        onChange={onFieldValueChange}
                        type="number"
                        style={{ width: width, height: "30px", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                    />
                </div>}
                {/* Keywords */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="Keywords" value={selectedFields.Keywords.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Keywords</span>
                    </div>
                    <input
                        disabled={!selectedFields.Keywords.isSelected}
                        name='Keywords'
                        onChange={onFieldValueChange}
                        type="text"
                        style={{ width: width, height: "30px", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                    />
                </div>}
                {/* Categories */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="Categories" value={selectedFields.Categories.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Categories</span>
                    </div>
                    <MyMultiSelect
                        disabled={!selectedFields.Categories.isSelected}
                        style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                        data={categories}
                        dataItemKey="_id"
                        textField="Name"
                        onChange={onFieldValueChange}
                        name={"Categories"}
                    />
                </div>}
                {/* Genres */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="Genres" value={selectedFields.Genres.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>{lang.genres_label}</span>
                    </div>
                    <MyMultiSelect
                        disabled={!selectedFields.Genres.isSelected}
                        style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                        data={genres}
                        dataItemKey="_id"
                        textField="Description"
                        onChange={onFieldValueChange}
                        name={"Genres"}
                    />
                </div>}
                {/* Sub Genres */}
                {mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="SubGenres" value={selectedFields.SubGenres.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>{lang.sub_genres_label}</span>
                    </div>
                    <MyMultiSelect
                        disabled={!selectedFields.SubGenres.isSelected}
                        style={{ width: width, maxHeight: "60px", overflow: "auto", border: "1px solid #E0E0E0", borderRadius: "4px", padding: "0 10px" }}
                        data={genres}
                        dataItemKey="_id"
                        textField="Description"
                        onChange={onFieldValueChange}
                        name={"SubGenres"}
                    />
                </div>}
                {/* Audio Track */}
                {!isHideMetaDataFields && mediaCategory.isLong && <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="AudioTrack" value={selectedFields.AudioTrack.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Audio Track</span>
                    </div>
                    <div style={{ width: width, borderRadius: "4px" }}>
                        <AudioTrack disabled={!selectedFields.AudioTrack.isSelected} dataItem={{ AudioTrack: [] }} setAudioTrackData={setAudioTrackData} />
                    </div>
                </div>}
                {/* linear */}
                <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="linearRights" value={selectedFields.linearRights.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Linear Rights</span>
                    </div>
                    <div style={{ width: width, borderRadius: "4px" }}>
                        <AddRoundButton disabled={!selectedFields.linearRights.isSelected} onClick={() => onMediadealrightsClose(true)} />
                        <div style={{ overflow: "auto", marginTop: "10px" }}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Channel</th>
                                        <th className="text-nowrap" scope="col">Start Date</th>
                                        <th className="text-nowrap" scope="col">End Date</th>
                                        <th className="text-nowrap" scope="col">Is Unlimited</th>
                                        <th scope="col">Exhibition</th>
                                        <th className="text-nowrap" scope="col">Repeat</th>
                                        <th className="text-nowrap" scope="col">Play Time Number</th>
                                        <th className="text-nowrap" scope="col">Play Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedFields.linearRights.value?.map((publishingData, index) => {
                                        return (
                                            <tr key={index}>
                                                <td><DeleteRoundButton disabled={!selectedFields.linearRights.isSelected} onClick={() => ConfirmDeleteAlert(() => onMediadealrightsDelete(publishingData), () => { })} /></td>
                                                <td className="text-nowrap" style={tableDataStyle}>
                                                    {utility.displayArrayInPipe(publishingData?.Channel, 'FullChannelName')}
                                                </td>
                                                <td className="text-nowrap" style={tableDataStyle}>
                                                    {moment(publishingData?.PublishStartDate).utc().format('DD-MM-YYYY')}
                                                </td>
                                                <td className="text-nowrap" style={tableDataStyle}>
                                                    {moment(publishingData?.PublishEndDate).utc().format('DD-MM-YYYY')}
                                                </td>
                                                <td style={tableDataStyle}>
                                                    <Checkbox style={{ borderColor: "black" }} disabled={true} value={publishingData?.IsUnlimited} />
                                                </td>
                                                <td style={tableDataStyle}>
                                                    {publishingData?.Exhibitions}
                                                </td>
                                                <td style={tableDataStyle}>
                                                    {publishingData?.Repeats}
                                                </td>
                                                <td style={tableDataStyle}>
                                                    {publishingData?.PlayTimeNumber}
                                                </td>
                                                <td style={tableDataStyle}>
                                                    {publishingData?.PlayTime?.Description}
                                                </td>
                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {/* non-linear */}
                <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="nonLinearRights" value={selectedFields.nonLinearRights.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Non-Linear Rights</span>
                    </div>
                    <div style={{ width: width, borderRadius: "4px" }}>
                        <AddRoundButton disabled={!selectedFields.nonLinearRights.isSelected} onClick={() => onMediadealrightsClose(false)} />
                        <div style={{ overflow: "auto", marginTop: "10px" }}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Platform</th>
                                        <th className="text-nowrap" scope="col">Start Date</th>
                                        <th className="text-nowrap" scope="col">End Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedFields.nonLinearRights.value?.map((publishingData, index) => {
                                        return (
                                            <tr key={index}>
                                                <td><DeleteRoundButton disabled={!selectedFields.nonLinearRights.isSelected} onClick={() => ConfirmDeleteAlert(() => onMediadealrightsDelete(publishingData), () => { })} /></td>
                                                <td className="text-nowrap" style={tableDataStyle}>
                                                    {utility.displayArrayInPipe(publishingData?.Platform, 'Description')}
                                                </td>
                                                <td className="text-nowrap" style={tableDataStyle}>
                                                    {moment(publishingData?.PublishStartDate).utc().format('DD-MM-YYYY')}
                                                </td>
                                                <td className="text-nowrap" style={tableDataStyle}>
                                                    {moment(publishingData?.PublishEndDate).utc().format('DD-MM-YYYY')}
                                                </td>
                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Offer */}
                <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="offers" value={selectedFields.offers.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Offers</span>
                    </div>
                    <div style={{ width: width, borderRadius: "4px" }}>
                        <AddRoundButton disabled={!selectedFields.offers.isSelected} onClick={() => setShowAttachOffers(true)} />
                        <div style={{ overflow: "auto", marginTop: "10px" }}>
                            <table className="table">
                                <thead>
                                    <tr className="text-nowrap">
                                        <th>Title</th>
                                        <th>Source</th>
                                        <th>Display Title</th>
                                        <th>Price Code</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedFields.offers.value?.map((offer, index) => {
                                        return (
                                            <tr className="text-nowrap" key={index}>
                                                <td style={tableDataStyle}>{offer?.Offer?.Title}</td>
                                                <td style={tableDataStyle}>{offer?.source}</td>
                                                <td style={tableDataStyle}>{offer?.Offer?.DisplayTitle}</td>
                                                <td style={tableDataStyle}>{offer?.Offer?.PriceCode?.Description}</td>
                                                <td style={tableDataStyle}>
                                                    {moment(offer?.Offer?.StartDateTime).utc().format('DD-MM-YYYY')}
                                                </td>
                                                <td style={tableDataStyle}>
                                                    {moment(offer?.Offer?.EndDateTime).utc().format('DD-MM-YYYY')}
                                                </td>
                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* <div style={style}>
                    <div>
                        <Checkbox style={{ borderColor: "black" }} name="OttAsset" value={selectedFields.OttAsset.isSelected} onChange={onCheckBoxSelection} />
                        <span style={subHeadingStyle}>Ott Asset</span>
                    </div>
                    <div>
                        <ActionButton name={'Enable Ott Asset'} />
                    </div>
                </div> */}
            </div>
            {showMediadealrights.show && <MediaDealRightEditForm isLinear={showMediadealrights.isLinear} onSave={onMediadealrightsSave} onClose={onMediadealrightsClose} />}
            {showAttachOffers && <CreateTransmissionForm onSubmit={handleAttachOffers} onClose={() => setShowAttachOffers(false)} />}
            {/* {showAttachOffers && <CollectionSelection title={lang.select_offers_label} entityname={ENTITYNAME.OFFER} setDataList={handleAttachOffers} closeForm={() => setShowAttachOffers(false)} mode={'multiple'} width={"50vw"} showCreate={true} path={`/home/offer`} />} */}
        </div>
    )
};

export default memo(MultipleContentEditPanel);